/**
 * Main JavaScript for KorroExpert theme
 * Compiled with esbuild
 */

// Import modules
import { initNavigation } from './modules/navigation';

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    console.log('KorroExpert Theme Loaded');

    // Initialize modules
    initNavigation();
});
